export const primary = "#003366";
export const secondary = "#990000";
export const backgroundColor = "#F2F4F7";

export const mobileScreeenMaxWidth = 500;

export const tabletScreenMaxWidth = 800;

export const desktopScreenMaxWidth = 1600;
